var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16253",
    "data-name": "Group 16253",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.028,
    height: 20.971,
    viewBox: "0 0 22.028 20.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8508",
    "data-name": "Rectangle 8508",
    width: 22.028,
    height: 20.971,
    fill: "#0082ca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16252",
    "data-name": "Group 16252",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5889",
    "data-name": "Path 5889",
    d: "M20.957,2.855H17.951V1.071a1.071,1.071,0,1,0-2.141,0V2.855H6.218V1.071a1.071,1.071,0,0,0-2.141,0V2.855H1.071A1.069,1.069,0,0,0,0,3.926V19.9a1.069,1.069,0,0,0,1.071,1.071H20.957A1.069,1.069,0,0,0,22.028,19.9V3.926A1.069,1.069,0,0,0,20.957,2.855ZM19.886,5V8.414H2.143V5ZM2.143,10.557H19.886V18.83H2.143Z",
    transform: "translate(0 0)",
    fill: "#0082ca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksDate);
export default __webpack_public_path__ + "static/media/tasks-date.4491b0472b0f22430535f9fd426cb7c6.svg";
export { ForwardRef as ReactComponent };